import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import mdEntityService from 'core/metamodel/mdEntityService';
import mdConfigService from "core/metamodel/mdConfigService";
import {BlockComp} from 'core/components/blockComp/blockComp';
import {parseId} from "core/common/utils/utils";
import {preSave, IDomainObject} from "core/form/formUtils";
import {ErrorComp} from "core/components/errorComp/errorComp"
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import FieldDefaultList from "core/metamodel/component/fieldDefaultList";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import MdEntity from "core/metamodel/mdEntity";
import {observer} from "mobx-react";
import {ZzFlatButton} from "core/components/buttons/buttons";
import uiService from "core/common/service/uiService";
import {action} from "mobx";
import FieldValidationList from "core/metamodel/component/fieldValidationList";
import {MdTextField} from "core/components/fields/fields";
import {fieldStyles} from "core/form/createForm";
import {loc} from "core/common/config/locales";
import {LocaleLabel} from "core/metamodel/metaDomain";
import gridService from "core/grid/gridService";
import {GridLocation} from "core/grid/domain/grid";
import LocalizeField from "core/components/fields/localizeField";
import LocalizeFields from "core/components/localization/localizeFields";

@observer
export default class GridLocationFieldDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Grid location field';
  static icon = 'book';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("GridLocationFieldDetail#fetchData(%O)", routerParams.id);

    const [gridLocationName, fieldName] = parseId(routerParams.id);

    let fieldDtoPromise = gridService.readGridLocationField(routerParams.id);
    let metadataPromise = mdEntityService.fetchEntityMetadata([], ['GridLocationField']);

    return Promise.all([fieldDtoPromise, metadataPromise])
      .then(([fieldDto, entityMap]) => {
        gridService.gridLocationFieldObject = fieldDto;
      });
  }


  componentWillUnmount() {
    gridService.gridLocationFieldObject = null;
  }


  findRootObject() {
    return gridService.gridLocationFieldObject;
  }


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();


    if (!preSave(gridService.gridLocationFieldObject)) {
      return;
    }

    gridService.saveGridLocationFieldDto(gridService.gridLocationFieldObject)
      .then(action("fieldDtoSave-action", (foJson: IDomainObject) => {
        let wasNew = gridService.gridLocationFieldObject.cleanAfterSave(foJson);
        uiService.hideToolbarActionFlag();
      }), error => {
        gridService.gridLocationFieldObject.$errors = error.getMessages();
      });
  };


  onBack = (evt) => {
    this.context.router.transitionTo('gridLocationDetail', {id: parseId(gridService.gridLocationFieldObject.gridLocationField)});
  };


  render() {

    let {
      query
    } = this.props;


    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(query.gridLocation)}
        <ErrorComp messages={gridService.gridLocationFieldObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>

        <form style={{marginTop: 10}}>
          <div className="row">

            <div className="col-xs-12">
                <LocalizeFields fields={gridService.gridLocationFieldObject.locales.entries().map(([fieldName, locArray]) => ({fieldName, locArray}))}/>
            </div>


          </div>
        </form>


      </main>
    );


  }


  _createToolMenu(gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={false}>
        <ZzFlatButton onClick={this.onSave} label="Save Field" permission={PERMISSION.Update}/>
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/gridLocationFieldDetail.tsx